import * as React from "react";
import type { AppIconPreviewGalleryProps } from "./AppIconPreviewGallery.types";
import type { ForwardRefComponent } from "@fluentui/react-components";
import { AppIconPreviewGalleryButton } from "../../AppIconPreviewGalleryButton/next";
// eslint-disable-next-line no-restricted-imports
import { AppPreviewGallery } from "@1js/acui-gallery/lib/Next";

export const AppIconPreviewGallery: ForwardRefComponent<AppIconPreviewGalleryProps> =
  React.memo(
    React.forwardRef<HTMLDivElement, AppIconPreviewGalleryProps>(
      (props, ref) => {
        const modifiedProps = {
          ...props,
          galleryButtons: props.galleryButtons.map((button) => {
            const { title, ...requiredProps } = button;
            return {
              ...requiredProps,
              styles: props.styles,
              customTooltip: button.customTooltip ?? title,
            };
          }),
        };
        const previewGalleryProps = {
          ...modifiedProps,
          getGalleryButtonComponent: AppIconPreviewGalleryButton,
          automationType: props.dataAutomationType || "AppIconPreviewGallery",
          uniqueId: props.id,
        };
        return <AppPreviewGallery {...previewGalleryProps} ref={ref} />;
      }
    ) as ForwardRefComponent<AppIconPreviewGalleryProps>
  );
